import { Box, Typography } from "@mui/joy";
import React, { useRef, useState } from "react";
import { Dialog } from 'primereact/dialog';
import GenericTableView from "../../components/GenericTableView";
import { GenericTableColumTypes } from "../../enum/TableView";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import { RouteComponentProps } from "../../models/RouteComponent";
import { useNavigate } from "react-router-dom";
import FormAllocationAdd from "./form-allocation-Add";
import { removeFormAllocation } from "../../service/formAllocationService";
import {FREQUENCIES} from "./constants";

export default function FormsAllocationTable(props: RouteComponentProps) {

  const navigate = useNavigate();

  const [selectedRecord, setSelectedRecord] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const dialog = useRef(null as any);
  const toast = useRef(null as any);

  let url = 'form-allocation';

  const baseFilter = { }

  const addButton = (row: any) => {
    setSelectedRecord(null);
    setVisible(true);
  }

  const itemSelected = (row: any) => {
    setSelectedRecord(row.value);
    viewSelected(row);
  }
  const contextItemSelected = (row: any) => {
    setSelectedRecord(row.value);
  }

  const viewSelected = (row: any) => {
    setVisible(true);
  }
  const contextItems = () => {
    let objArray = [
      { label: 'View / Edit', icon: 'pi pi-fw pi-pencil', command: viewSelected },
    ];
    objArray.push({ label: 'Delete', icon: 'pi pi-fw pi-trash', command: deleteConfirm });
    return objArray;
  }

  const deleteFormAllocation = async () => {
    props.setGlobalLoader(true);
    await removeFormAllocation(selectedRecord.id);
    props.setGlobalLoader(false);
    setReload(true);
    toast.current.show({ severity: 'success', summary: 'Form Allocation Deleted', life: 3000 });
  }
  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => deleteFormAllocation()
    });
  }

  const columns: GenericTableColumns[] = [
    {
      field: 'form_name',
      header: 'Form',
      type: GenericTableColumTypes.Text,
      visible: true,
    },
    {
      field: 'frequency',
      header: 'Frequency',
      visible: true,
      type: GenericTableColumTypes.Template,
      template: (rowData: any) => {
        return FREQUENCIES.find((item: any) => item.value === rowData.frequency)?.label;
      }
    },
    {
      field: 'description',
      header: 'Description',
      type: GenericTableColumTypes.Text,
      visible: true,
    },
    {
      field: 'industries',
      header: 'Industries',
      visible: true,
      type: GenericTableColumTypes.Template,
      template: (rowData: any) => {
        return rowData.industries.join(', ');
      }
    },
    {
      field: 'appointments',
      header: 'Appointments',
      visible: true,
      type: GenericTableColumTypes.Template,
      template: (rowData: any) => {
        return rowData.appointments.join(', ');
      }
    },
    {
      field: '',
      header: 'Override count',
      visible: true,
      type: GenericTableColumTypes.Template,
      template: (rowData: any) => {
        return rowData.client_overrides.length.toString();
      }
    },
  ];


  return (
    <React.Fragment>
      <Box>
        <Typography level="h2" component="h1">
          Form Allocations
        </Typography>
      </Box>

      <GenericTableView reload={reload} baseFilters={baseFilter} url={url} columns={columns}
                        contextItems={contextItems} addButton={addButton} itemSelect={itemSelected}
                        contextItemSelected={contextItemSelected} />

      <Dialog ref={dialog} header={selectedRecord?.id ? 'Update Form Allocation' : 'Add Form Allocation'}
              visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)}>
        <FormAllocationAdd setGlobalLoader={props.setGlobalLoader} setReload={setReload} reload={reload}
                           id={selectedRecord?.id} record={selectedRecord} setVisible={setVisible} toast={toast}  />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />

    </React.Fragment>
  );
}